import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

interface ServiceCardProps {
  image?: string;
  title: string;
  description: string;
  link: string;
  alt: string;
}

export function ServiceCard({ image, title, description, link, alt }: ServiceCardProps) {
  return (
    <Link
      to={link}
      className="group bg-card rounded-xl overflow-hidden border border-border hover:border-secondary/50 transition-all duration-300"
    >
      {image && (
        <div className="aspect-[4/3] overflow-hidden">
          <img
            src={image}
            alt={alt}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
            loading="lazy"
          />
        </div>
      )}
      <div className="p-5">
        <h3 className="text-lg font-bold mb-2 group-hover:text-secondary transition-colors">
          {title}
        </h3>
        <p className="text-muted-foreground text-sm mb-3">
          {description}
        </p>
        <span className="text-secondary font-medium text-sm flex items-center gap-1">
          Learn More <ArrowRight className="h-4 w-4" />
        </span>
      </div>
    </Link>
  );
}
